var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import { usePreviewLoop } from 'hx-din-test-2';
import { StepLayout } from '../step-layout.component';
import { pageImages } from '@/pages/images';
import { VolumeSelectContent } from './volume-select-content.component';
export function VolumeSelect() {
    var state = usePreviewLoop().dinPlayer.state;
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsx(StepLayout, { image: pageImages.manReadsBook, showProgress: false, heading: "Ajustez le volume \u00E0 un", subHeading: "niveau d'\u00E9coute confortable", content: _jsx(VolumeSelectContent, {}) }));
}
